import {useEffect, useState} from "react";
import styled from 'styled-components';

import {FormControl, FormHelperText, useToast} from "@chakra-ui/react";
import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {useCommunityDesignToken, useSetCommunityDesign} from "../../../api/create_image";
import {useReloadCommunity} from "../../../api/communities";

const UploadText = styled.div``;
const LogoUpload = styled.div``;
const HeaderUpload = styled.div``;
const SwitchHeading = styled.div``;

const DesignCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [logo, setLogo] = useState(null);
    const [header, setHeader] = useState(null);

    const uploadToken = useCommunityDesignToken(feedbackCh);
    const setCommunityDesign = useSetCommunityDesign(feedbackCh);
    const reloadCommunity = useReloadCommunity(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    if (logo || header) {
                        const token = await uploadToken(community, header ? true : false, logo ? true : false);
                        await setCommunityDesign(header, logo, token);
                        await reloadCommunity([community]);
                    }
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Community Design" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <SwitchHeading>Community Logo</SwitchHeading>
                    <FormControl mb={'32px'}>
                        <UploadText style={{marginBottom: 16}}>
                            <FormHelperText mt={'2px'}>Recommended size: 512x512px</FormHelperText>
                        </UploadText>
                        <input type={"file"} onChange = {(e) => setLogo(e.target.files[0])}/>
                    </FormControl>

                    <SwitchHeading>Community Header</SwitchHeading>
                    <FormControl mb={'16px'}>
                        <HeaderUpload>
                            <UploadText style={{marginBottom: 16}}>
                                <FormHelperText mt={'2px'}>Recommended size: 1920x1080px</FormHelperText>
                            </UploadText>
                            <input type={"file"} onChange = {(e) => setHeader(e.target.files[0])}/>
                        </HeaderUpload>
                    </FormControl>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`

  ${LogoUpload} {
    display: flex;
    align-items: center;
    margin: 8px 0 20px 0;
  }

  ${LogoUpload} ${UploadText} {
    margin-left: 24px;
  }
  

  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 0;
  }
`;

export default DesignCommunitySettings;
